import styled from 'styled-components';

export const ContainerFiltro = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  
`;
export const FabContainer = styled.div`
  .fab{
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 999;
  }
`;

